
















import { Component, Vue } from "vue-property-decorator";
@Component
export default class TheAboutList extends Vue {
  color = this.$store.state.config.color;

  items = [
    {
      text: "Impressum",
      url: "https://www.mmmint.ai/impressum",
      target: "_blank",
      icon: "mdi-information-outline"
    },
    {
      text: "Datenschutz",
      url: "https://www.mmmint.ai/datenschutz",
      target: "_blank",
      icon: "mdi-shield-sun-outline"
    },
    {
      text: "AGBs",
      url: "https://www.mmmint.ai/agbs",
      target: "_blank",
      icon: "mdi-handshake-outline"
    }
  ];

  route(route: string) {
    this.$router.push({ name: route });
  }
}
